import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EventEmitter, ViewChild, ViewContainerRef } from "@angular/core";
import { AppService } from "@api";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { Evaluacion } from "@modelo/global/Evaluacion.model";
import { EvaluacionPendienteColaboradorIntermedioComponent } from "./colaboradorintermedio.component";


@Component(
    {
        selector: 'colaborador',
        templateUrl: './colaborador.component.html',
        styleUrls: ['./colaborador.component.scss']
    })

export class ColaboradorComponent implements AfterViewInit {
    consulta!: boolean;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string;

    dataTable:any[];
    cicloactual: number = 0;
    periodoevaluacionseleccion: number = 0;

    SelDepartamento:any[];
    SelCiclo:any[];
    SelPeriodoevaluacion:any[];
    SelPuesto:any[];

    @ViewChild("containerEvaluacion", {read: ViewContainerRef}) containerEvaluacion!: ViewContainerRef;
    
    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
        this.uriApi = "evaluacionpendiente/colaborador/buscar";

        this.dataTable = [];
        this.SelDepartamento = [];
        this.SelPeriodoevaluacion = [];
        this.SelCiclo = [];
        this.SelPuesto = [];
        this.GenerarFiltros();
    }

    ngAfterViewInit(){
       this.LoadDatos().then((respuesta : any)=>{
            this.filtrosComponent.SetFiltros(this.filtrosDisplay, true);
       })
    }

    //Genera el filtro para los periodos de evaluacion
    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Valor: this.cicloactual,
                    Titulo: 'Ciclo',
                    DisplayValor: 'nombre',
                    ValorName: 'cicloid',
                    Opciones: this.SelCiclo,
                    Propiedad: "cicloid",
                    Obligatorio: true,
                    Buscar: false,
                    Suscripcion: new EventEmitter()
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Periodo evaluación',
                    DisplayValor: 'descripcion',
                    ValorName: 'periodoevaluacionid',
                    Opciones: this.SelPeriodoevaluacion,
                    Propiedad: "periodoevaluacionid",
                    Obligatorio: false,
                    Buscar: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Persona a evaluar',
                    MensajeError: "",
                    Propiedad: 'nombre',
                    Obligatorio: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Estatus',
                    DisplayValor: 'nombre',
                    ValorName: 'evaluacionestatusid',
                    Opciones: [{"evaluacionestatusid":0, "nombre":"Pendiente"}, {"evaluacionestatusid":1, "nombre":"Terminada"}],
                    Propiedad: "evaluacionestatusid",
                    Obligatorio: false,
                    Buscar: false,
                })
        );
        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Departamento',
                    DisplayValor: 'nombre',
                    ValorName: 'departamentoid',
                    Opciones: this.SelDepartamento,
                    Propiedad: "departamentoid",
                    Obligatorio: false,
                    Buscar: true,
                    Suscripcion: new EventEmitter()
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Puesto',
                    DisplayValor: 'nombre',
                    ValorName: 'puestoid',
                    Opciones: this.SelPuesto,
                    Propiedad: "puestoid",
                    Obligatorio: false,
                    Buscar: true
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    async LoadDatos(){
      return new Promise((resolve) =>{
          Promise.all([
          this.SetDepartamentoFiltro(),
          this.SetCiclo(),
        ]).then((responses : any) =>{
          return resolve(responses);
        });
      });
    }

    //Trae las departamento para el filtro de las personas a evaluar
    SetDepartamentoFiltro() {
        return new Promise((resolve : any) =>{
            this.appService.Post("configuracionrh/departamento/buscar", {activo: 1}).then(res =>{
                if (res.status == RespuestaEstatusEnum.Success){
                    this.SelDepartamento = res.data;
                    let prueba = {"departamentoid": 0, "nombre": "Todos"}
                    this.SelDepartamento.unshift(prueba)
                    let filtro = this.filtrosDisplay.find(x => x.ValorName == 'departamentoid');
                    if (filtro){
                        filtro.Opciones = this.SelDepartamento;
                        filtro.Suscripcion.subscribe((v: number) =>{
                            this.SetPuestoFiltro(v).then((respuesta : any) =>{
                            });
                        });

                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                }
                else{
                    return resolve(false);
                }
            });
        });
    }

    SetCiclo(){
        return new Promise ((resolve) =>{
            this.appService.Get("catalogo/ciclo").then(res=>{
                if(res.status == RespuestaEstatusEnum.Success)
                {
                    this.SelCiclo = res.data;
                    let filtro = this.filtrosDisplay.find(x => x.ValorName == 'cicloid');
                    if (filtro){
                        filtro.Opciones = this.SelCiclo;
                        let valor = filtro.Opciones.find(x=>x.actual == 1);
                        if(valor){
                            filtro.Valor = valor.cicloid;
                            this.SetPeriodoevaluacion(valor.cicloid).then((respuesta : any) =>{
                                return resolve(respuesta);
                            });
                        }

                        filtro.Suscripcion.subscribe((v: number) =>
                        {
                            this.SetPeriodoevaluacion(v).then((respuesta : any) =>
                            {
                            });
                        });
                    }
                    else{
                        return resolve(false);
                    }
                }
                else{
                    return resolve(false);
                }
            })
        });
    }

    SetPeriodoevaluacion(id:number){
        return new Promise ((resolve) =>{
            let filtro = this.filtrosDisplay.find(x => x.ValorName == 'periodoevaluacionid');
            let filtroindex = this.filtrosDisplay.findIndex(x => x.ValorName == 'periodoevaluacionid');

            if (filtro){
                filtro.Valor = null;
                if (!id) {
                    this.SelPeriodoevaluacion = [];
                    filtro.Opciones = this.SelPeriodoevaluacion;
                    return resolve(false);
                }
                this.appService.Post("planeacion/periodoevaluacion/buscar",{"cicloid":id}).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success) {
                        this.SelPeriodoevaluacion = res.data;
                        if(filtro){
                            if(this.filtrosComponent.filtrosSeleccionados.length > 0){
                                this.filtrosComponent.filtrosSeleccionados[filtroindex].Opciones = this.SelPeriodoevaluacion;
                            }else{
                                filtro.Opciones = this.SelPeriodoevaluacion;
                            }
                        }
                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                });
            }
            else{
                return resolve(false);
            }
        });
    }

    //Trae las puesto para el filtro de las personas a evaluar
    SetPuestoFiltro(id:number){
        return new Promise ((resolve) =>{
            let filtro = this.filtrosDisplay.find(x => x.ValorName == 'puestoid');
            let filtroindex = this.filtrosDisplay.findIndex(x => x.ValorName == 'puestoid');

            if (filtro){
                filtro.Valor = null;
                if (!id){
                    this.SelPuesto = [];
                    filtro.Opciones = this.SelPuesto;
                    return resolve(true);
                }
                this.appService.Post("configuracionrh/puesto/buscar", {activo: 1, "departamentoid":id}).then(res =>{
                    if (res.status == RespuestaEstatusEnum.Success){
                        this.SelPuesto = res.data;
                        if (filtro){
                            if(this.filtrosComponent.filtrosSeleccionados.length > 0){
                                this.filtrosComponent.filtrosSeleccionados[filtroindex].Opciones = this.SelPuesto;
                            }else{
                                filtro.Opciones = this.SelPuesto;
                            }

                        }
                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                });
            }
            else{
                return resolve(false);
            }
        });
    }

    SetDatos(data: any) {
        this.dataTable = data;
    }

    Formulario(data:any){
        this.cargarContenedorFormulario({data:data});

    }

    //Carga el contenedor con la informacion de la evaluacion
    cargarContenedorFormulario(data: {data:any}) {
        this.consulta = true;
        this.containerEvaluacion.clear();
        const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(EvaluacionPendienteColaboradorIntermedioComponent);
        var ref: ComponentRef<any> = this.containerEvaluacion.createComponent(factory);
        ref.instance.entidad = new Evaluacion(data.data);
        ref.instance.output.subscribe((cambio: boolean) => {
            this.consulta = false;
            ref.destroy();
            if (cambio) {
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
        });
    }
}